import { create } from "zustand";
import { InvestorAmlDetail } from "../api/transformers/aml";
import { AmlAPI } from "../api";

export type InvestorAmlDetailStore = {
  data: InvestorAmlDetail | null,
  loading: boolean;
  error: unknown | null;
  fetchData: (personId: string) => void;
}

const useInvestorAmlDetailStore = create<InvestorAmlDetailStore>((set) => ({
  data: null,
  loading: true,
  error: null,
  // actions
  fetchData: async (personId) => {
    set({ loading: true, error: null, data: null });
    try {
      const result = await AmlAPI.getInvestorAmlDetail(personId);
      set({ data: result, loading: false });
    } catch (err) {
      console.error(err);
      set({ error: err, loading: false });
    }
  }
}));

export default useInvestorAmlDetailStore;
